import React from 'react';
import { Button } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { useTranslate } from '../../hooks/use-translate.hook';

interface BackButtonProps {
  onClick?: () => void;
  label?: string;
  size?: 'small' | 'middle' | 'large';
}

const BackButton: React.FC<BackButtonProps> = ({ onClick, label, size = 'large' }) => {
  const navigate = useNavigate();
  const { t } = useTranslate();

  return (
    <Button
      type="default"
      icon={<ArrowLeftOutlined />}
      size={size}
      onClick={onClick || (() => navigate(-1))}
    >
      {label ?? t('common.back')}
    </Button>
  );
};

export default BackButton;
